module.exports = __webpack_public_path__ + "img/step3-b.97ecca9f.png";